import React, { useState, useEffect } from 'react';
import {
    Grid,
    IconButton,
    Tooltip,
} from '@mui/material';
import { AddBox as AddBoxIcon, Delete as DeleteIcon } from '@mui/icons-material';
import Autocomplete from '../common/Autocomplete';
import { useSelector } from 'react-redux';

const DeviceAttributesSelector = ({
    value = [],
    onChange,
    options = [],
    translate,
}) => {
    const themecolors = useSelector((state) => state.themeColors);
    const [rows, setRows] = useState(() =>
        value.length ? value.map((v) => ({ value: v, input: '', index: '' })) : [{ value: '', input: '', index: '' }]
    );
    useEffect(() => {
        setRows(value.length ? value.map((v) => ({ value: v, input: '', index: '' })) : [{ value: '', input: '', index: '' }]);
    }, [value]);

    const normalizeOptions = (opts) =>
        opts.map(({ key }) => ({ key, value: key, name: key }));

    const filteredOptions = options.filter(
        (opt) => !rows.some((r) => r.value === opt.key)
    );
    const normalizedOptions = normalizeOptions(filteredOptions);
    const suggestionKeys = normalizedOptions.map((opt) => opt.key);
    const handleAddRow = () => {
        if (rows.length < 2) {
            setRows((prev) => [...prev, { value: '', input: '', index: '' }]);
        }
    };

    const handleDeleteRow = (index) => {
        const updated = rows.filter((_, i) => i !== index);
        setRows(updated);
        onChange?.(updated.map((r) => r.value).filter(Boolean));
    };

    const handleRowChange = (newValue, index) => {
        const updated = [...rows];
        updated[index].value = newValue;
        setRows(updated);
        onChange?.(updated.map((r) => r.value).filter(Boolean));
    };

    return (
        <div style={{ marginBottom: 16, width: '100%' }}>
            {rows?.map((row, index) => (
                <Grid container spacing={1} key={index} alignItems="center" style={{ marginBottom: 8 }}>
                    <Grid item xs={11}>
                        <Autocomplete
                            value={row.value || ''}
                            suggestions={suggestionKeys}
                            handleChange={(e, newVal) => handleRowChange(newVal || '', index)}
                            fieldName="input"
                            label={translate('selectAttribute')}
                        />
                    </Grid>

                    <Grid item xs={1}>
                        <div style={{ display: 'flex', gap: 4 }}>
                            {rows.length < 2 && (
                                <Tooltip title={translate('addMore')}>
                                    <IconButton onClick={handleAddRow}
                                        sx={{
                                            backgroundColor: themecolors?.themeLightColor,
                                            color: themecolors?.themeLightInverse,
                                            borderRadius: 1,
                                            padding: "0.2rem",
                                            '&:hover': {
                                                backgroundColor: themecolors?.themeLightColor,
                                            },
                                        }}>
                                        <AddBoxIcon />
                                    </IconButton>
                                </Tooltip>
                            )}
                            {rows.length > 1 && (
                                <Tooltip title={translate('delete')}>
                                    <IconButton onClick={() => handleDeleteRow(index)}
                                        sx={{
                                            backgroundColor: themecolors?.themeLightColor,
                                            color: themecolors?.themeLightInverse,
                                            borderRadius: 1,
                                            padding: "0.2rem",
                                            '&:hover': {
                                                backgroundColor: themecolors?.themeLightColor,
                                            },
                                        }}
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                </Tooltip>
                            )}
                        </div>
                    </Grid>
                </Grid>
            ))}
            {rows.length >= 2 && (
                <div  style={{ fontWeight: "bold", color: "#ffc107", fontSize: "12px" }}>
                    {translate('You can only select up to 2 attributes.')}
                </div>
            )}
        </div>

    );
};

export default DeviceAttributesSelector;
